class SelectController {
    constructor(select) {
        if (!select) {
            return;
        }
        this.select = select;
        this.hiddenValue = '';
        this.hiddenSelect = this.select.querySelector('select');
        this.selectValue = this.select.querySelector('.select-component__value');
        this.dropdpwn = this.select.querySelector('.select-component__output');
        this.dropdpwnValues = this.dropdpwn.querySelectorAll('[data-list-value]');
        this.init();
    }

    init() {
        this.select.addEventListener('click', () => {
            this.select.classList.toggle('select-component--open');
        });

        this.dropdpwnValues.forEach((el) => {
            el.addEventListener('click', () => {
                
                const value = el.dataset.listValue;
                
                if (this.hiddenValue !== value) {
                    const findedItem = Array.from(this.dropdpwnValues).find((el) => el.classList.contains('disable'));

                    if (findedItem) {
                        findedItem.classList.remove('disable');
                    };

                }
                
                el.classList.add('disable');

                this.selectValue.textContent = el.textContent;
                this.hiddenValue = value;

                const options = Array.from(this.hiddenSelect.querySelectorAll('option'));
                options.forEach((option) => {
                    option.removeAttribute('selected');
                })
                this.hiddenSelect.value = value;
                const targetOption = options.find((option) => {
                    return option.value === value
                });
                targetOption.selected = true;
                const event = new Event('change', {
                    bubbles: true, 
                    cancelable: true
                });
                this.hiddenSelect.dispatchEvent(event);
            });
        });

        this.checkClickOutside();
    }

    checkClickOutside() {

        document.addEventListener('click', (event) => {
            const withinBoundaries = event.composedPath().includes(this.select)
        
            if (!withinBoundaries) {
                this.select.classList.remove('select-component--open');
            }

        }); 
    }
}

const selects = document.querySelectorAll('.select-component');

selects.forEach((el) => {
    new SelectController(el);
});
